import React, {FC} from "react"

import {QueryDealsBrandsArgs, DealBrandSearchResponse} from "@irati/types/ops"
import Query, {QueryComponentProps} from "@irati/utils/services/apollo/Query"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"

import dealsBrandsQuery from "../../services/queries/dealsBrands"

interface Props extends Omit<QueryComponentProps<{dealsBrands: DealBrandSearchResponse}, QueryDealsBrandsArgs>, "query"> {}

const SearchBrands: FC<Props> = ({children, ...props}) => {
  const query = dealsBrandsQuery

  return (
    <Query query={query} {...props} useLoader={false} useError={false}>
      {(apollo: ApolloState) => {
        return children(apollo)
      }}
    </Query>
  )
}

export default SearchBrands
